import {loadScript} from "./utilities/loadScript";

export function lottieLoader() {
    const lottieWrapper = document.querySelectorAll('.js-lottie');
    if(lottieWrapper.length > 0){
        loadScript('/plugins/lottie/lottie.min.js').then(() => {
            for (const lottieLoader of lottieWrapper) {
                lottie.loadAnimation({
                    wrapper: lottieLoader,
                    animType: 'svg',
                    loop: true,
                    autoplay: true,
                    path: lottieLoader.dataset.path
                });
            }
        }).catch(() => {
            console.log('Error loading lottie');
        });
    }
}